import { createApp } from 'vue'
import Antd from 'ant-design-vue'
import router from './router'
import App from './App.vue'
import 'ant-design-vue/dist/reset.css'



createApp(App).use(router).use(Antd).mount('#app')

function mustGetEnv(key) {
    const value = process.env[key]
    if (!value) {
        throw new Error(`Missing env: ${key}`)
    }
    return value
}

function getEnv(key, defaultValue = '') {
    return process.env[key] || defaultValue
}

const serviceUrl = {
    backendUrl: mustGetEnv('VUE_APP_BACKEND_URL'),
    imageBaseUrl: mustGetEnv('VUE_APP_IMAGE_BASE_URL'),
    scholatBaseUrl: mustGetEnv('VUE_APP_SCHOLAT_BASE_URL'),
    scholatAcademicBase: mustGetEnv('VUE_APP_SCHOLAT_ACADEMIC_BASE'),
    scholatProfileSyncUrl: mustGetEnv('VUE_APP_SCHOLAT_PROFILE_SYNC_URL'),
    adminLoginUrl: mustGetEnv('VUE_APP_ADMIN_LOGIN_URL'),
    universityName: getEnv('VUE_APP_UNIVERSITY_NAME', 'gpnu'),
    facultySchoolUrl: getEnv('VUE_APP_FACULTY_SCHOOL_URL', 'https://www.gpnu.edu.cn/'),
    facultySiteUrl: getEnv('VUE_APP_FACULTY_SITE_URL', 'https://dxxy.gpnu.edu.cn/'),
    facultyschool: getEnv('VUE_APP_FACULTY_SCHOOL', '\u7535\u5b50\u4e0e\u4fe1\u606f\u5b66\u9662'),
}

export default serviceUrl
